import React, { useEffect, useState } from "react";
import {
  Rating,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import { AccountCircle } from "@mui/icons-material";
import CallIcon from "@mui/icons-material/Call";
import RatingPopup from "./RatingPopup";
import { cancelDoctorAppointment } from "../../apiservices/ApiService";

const ConsultationList = ({ appointments }) => {
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [isAppointment, setIsAppointment] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [appointmentToCancel, setAppointmentToCancel] = useState(null);

  const handleCardActionClick = (appointment) => {
    if (appointment.cardActionText === "Cancel") {
      setAppointmentToCancel(appointment);
      setShowCancelModal(true);
    } else if (appointment.cardActionText !== "You rated") {
      setIsAppointment(true);
      setSelectedAppointment(appointment);
    }
  };

  const handleRatingSubmitted = () => {
    setIsAppointment(false);
    setSelectedAppointment(null);
  };

  const handleCancelConfirmation = async (confirmed) => {
    if (confirmed && appointmentToCancel) {
      try {
        await cancelDoctorAppointment({
          appointmentId: appointmentToCancel.appointmentId,
        });

        setShowCancelModal(false);
        setAppointmentToCancel(null);
        window.location.reload();
      } catch (error) {
        alert("Failed to cancel appointment. Please try again.");
      }
    } else {
      setShowCancelModal(false);
      setAppointmentToCancel(null);
    }
  };

  const getImageUrl = (imageUrl) => {
    if (imageUrl && imageUrl.startsWith("http://")) {
      return imageUrl.replace("http://", "https://");
    }
  };

  useEffect(() => {}, [selectedAppointment]);

  return (
    <div style={{ marginTop: "20px" }}>
      {appointments.map((appointment, index) => (
        <div
          key={appointment.appointmentId || index}
          style={{
            border: "1px solid #ddd",
            background: "linear-gradient(to top, #fff 0%, rgba(255, 152, 0, 0.2) 100%)",
            borderRadius: "8px",
            padding: "16px",
            marginBottom: "16px",
            // background: "#fff",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            {appointment.userImage ? (
              <img
                src={appointment.userImage}
                alt="User"
                style={{
                  width: "46px",
                  height: "46px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            ) : (
              <AccountCircle
                style={{ fontSize: "46px", color: "gray", borderRadius: "50%" }}
              />
            )}
            <div style={{ flex: 1 }}>
              <h5 style={{ margin: 0 }}>{appointment.bookedFor}</h5>
              <p style={{ margin: 0, color: "gray", fontSize: "14px" }}>
                {appointment.bookedBy}
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginTop: "20px",
            }}
          >
            <IconButton>
              <CallIcon />
            </IconButton>
            <div style={{ flex: 1 }}>
              <h5 style={{ margin: 0 }}>{appointment.displayDate}</h5>
              <p style={{ margin: 0, color: "gray", fontSize: "14px" }}>
                {appointment.reason}
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginTop: "20px",
            }}
          >
            <img
              src={getImageUrl(appointment.drImage)}
              alt="Doctor"
              style={{
                width: "46px",
                height: "46px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
            <div style={{ flex: 1 }}>
              <h5 style={{ margin: 0 }}>{appointment.drName}</h5>
              <p style={{ margin: 0, color: "gray", fontSize: "14px" }}>
                {appointment.status}
              </p>
            </div>
          </div>
          <div style={{ flex: 1, marginTop: "14px", fontSize: "14px" }}>
            {appointment.reason}
          </div>
          {appointment.cardActionText && (
            <>
              <div style={{ borderTop: "1px solid gray", margin: "16px 0" }} />
              <div
                style={{
                  marginTop: "12px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor:
                    appointment.cardActionText === "You rated"
                      ? "default"
                      : "pointer",
                  color:
                    appointment.cardActionText === "You rated"
                      ? "gray"
                      : "green",
                }}
                onClick={
                  appointment.cardActionText === "You rated"
                    ? null
                    : () => handleCardActionClick(appointment)
                }
              >
                {appointment.cardActionText}
              </div>
            </>
          )}
          {appointment.rating > 0 && (
            <div style={{ marginTop: "10px" }}>
              <strong>Rating: </strong>
              <Rating
                name={`rating-${index}`}
                value={appointment.rating}
                readOnly
              />
            </div>
          )}
        </div>
      ))}
      {isAppointment && selectedAppointment && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1000,
            background: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          }}
        >
          <RatingPopup
            doctorImage={selectedAppointment.drImage}
            doctorName={selectedAppointment.drName}
            appointmentId={selectedAppointment.appointmentId}
            onRatingSubmitted={handleRatingSubmitted}
          />
        </div>
      )}
      <Dialog open={showCancelModal} onClose={() => handleCancelConfirmation(false)}>
        <DialogTitle>Cancel Consultation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to cancel the consultation?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleCancelConfirmation(false)}
            color="secondary"
            variant="outlined"
          >
            No
          </Button>
          <Button
            onClick={() => handleCancelConfirmation(true)}
            color="primary"
            variant="contained"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ConsultationList;